import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"

import { aptSearchStore } from "@/routes/select/apt/apt-search-store"

const useAptNavigation = () => {
  const { region, aptCode } = useParams()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()
  const { pickApt } = aptSearchStore()

  const section = pathname.split("/").at(4)
  const resource = searchParams.get("resource")

  const goPage = (page) => {
    navigate(`/apt/${region}/${aptCode}/${page}`)
  }

  const goResource = (section, resource) => {
    const params = new URLSearchParams(searchParams)

    params.set("resource", resource)

    const sectionQueries = {
      stats: ["start_date", "end_date"],
      units: ["dong", "ho"]
    }

    const allowedQueries = sectionQueries[section] ?? []

    for (const key of ["start_date", "end_date", "dong", "ho"]) {
      if (!allowedQueries.includes(key)) {
        params.delete(key)
      }
    }

    navigate(`/apt/${region}/${aptCode}/${section}?${params.toString()}`)
  }

  const isResourceVisible = (resource) => {
    if (pickApt?.heat_type === 1 && ["hotwater", "hot"].includes(resource)) {
      return false
    }

    return true
  }

  return {
    region,
    aptCode,
    section,
    resource,
    searchParams,
    goPage,
    goResource,
    isResourceVisible
  }
}

export default useAptNavigation
